
import menus from 'constants/menus'

const selectHeaderMenu = (): typeof menus.headerNav => menus.headerNav

export default selectHeaderMenu
